export default __webpack_public_path__ + "static/media/lunch4.2de36fc8.png";